var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HdSelect',{attrs:{"value":_vm.value[_vm.index],"name":(_vm.name + "-" + _vm.index),"label":_vm.label,"options":_vm.computedOptions},on:{"input":_vm.inputHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }